import React from "react";
import { Button } from "antd";
import { useHistory } from "react-router";
import "./SkipButton.less";

export const SkipButton = () => {
  const history = useHistory();

  return (
    <Button
      shape="round"
      htmlType="button"
      size="large"
      className="skipBtn mr-2"
      onClick={() => history.push("/")}
    >
      Skip
    </Button>
  );
};
